module.exports = __webpack_public_path__ + "c_static/img/3加入购物车.02114cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/3加入购物车.jpg
// module id = q7Li
// module chunks = 33